/// <amd-module name="TFS/FeatureManagement/Components/FeatureBanner/FeatureCallout" />
import * as React from "react";

import { FormatComponent } from "VSS/Platform/Components/Format";
import { Callout } from "VSSUI/Callout";
import { Location } from "VSSUI/Utilities/Position";

export interface IFeatureCalloutComponentProps {
    headerText: string;
    bodyFormat: string;
    bodyFormatArgs: JSX.Element[];
    onDismiss: (ev?: any) => void;
}

export interface IFeatureCalloutComponentState {
    fadingOut: boolean;
}

export class FeatureCalloutComponent extends React.Component<IFeatureCalloutComponentProps, IFeatureCalloutComponentState> {
    private static INITIAL_START_FADE_TIMEOUT = 3000;
    private static FADE_CLOSE_TIMEOUT = 3000;
    private static INITIAL_ENTER_TIMEOUT = 2000;

    private _fadingTimeout: number | undefined;
    private _initialFadeTimeout: number | undefined;
    private _initialMouseEnterTimeout: number | undefined;

    private _mouseEntered: boolean;

    constructor(props: IFeatureCalloutComponentProps) {
        super(props);
        this.state = {
            fadingOut: false
        };
    }

    public componentDidMount() {
        this._initialFadeTimeout = window.setTimeout(() => {
            if (!this._mouseEntered) {
                this._startFadeOut();
            }
        }, FeatureCalloutComponent.INITIAL_START_FADE_TIMEOUT);

        this._initialMouseEnterTimeout = window.setTimeout(() => {
            this._initialMouseEnterTimeout = undefined;
        }, FeatureCalloutComponent.INITIAL_ENTER_TIMEOUT);
    }

    public componentWillUnmount() {
        window.clearTimeout(this._fadingTimeout!);
        window.clearTimeout(this._initialFadeTimeout!);
        window.clearTimeout(this._initialMouseEnterTimeout!);
    }

    public render(): JSX.Element {
        return (
            <Callout
                anchorElement={document.querySelector(".navigation-profile-menu, .me-control-div") as HTMLElement}
                anchorOrigin={{ horizontal: Location.end, vertical: Location.end }}
                anchorOffset={{ horizontal: 0, vertical: 1 }} // Vertical 1px is necessary not to cut page header border bottom
                calloutOrigin={{ horizontal: Location.end, vertical: Location.start }}
                className={"features-callout" + (this.state.fadingOut ? " fading-out" : "")}
                contentShadow={true}
                onDismiss={this.props.onDismiss}
            >
                <div className="callout-content" onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
                    <p className="callout-header">{this.props.headerText}</p>
                    <FormatComponent elementType="p" format={this.props.bodyFormat}>
                        {this.props.bodyFormatArgs}
                    </FormatComponent>
                </div>
            </Callout>
        );
    }

    private _startFadeOut() {
        this.setState({ fadingOut: true });

        this._fadingTimeout = window.setTimeout(() => {
            this.props.onDismiss();
        }, FeatureCalloutComponent.FADE_CLOSE_TIMEOUT);
    }

    private _onMouseEnter = (): void => {
        if (!this._initialMouseEnterTimeout && !this._mouseEntered) {
            this._mouseEntered = true;
            window.clearTimeout(this._fadingTimeout!);
            this.setState({ fadingOut: false });
        }
    };

    private _onMouseLeave = (): void => {
        if (!this._initialMouseEnterTimeout && this._mouseEntered) {
            this._mouseEntered = false;
            this.props.onDismiss();
        }
    };
}
